/**
 * Brand slug stamped on <html> by the theme engine for clients whose
 * ClientTheme declares a `brand`. Lets shared layout components render a
 * brand-specific shell without every screen having to know about it.
 * A new product's login shell starts here: add its slug, then its
 * BrandShellConfig in src/brands/index.ts (see CLAUDE.md, "Brand Shells").
 */
export const BRANDS = ["guestmaker", "wifibot", "admin"] as const;
export type Brand = (typeof BRANDS)[number];

export const BRAND_ATTRIBUTE = "data-ul-brand";

export function getActiveBrand(): Brand | undefined {
  if (typeof document === "undefined") return undefined;
  const value = document.documentElement.getAttribute(BRAND_ATTRIBUTE);
  return (BRANDS as readonly string[]).includes(value ?? "")
    ? (value as Brand)
    : undefined;
}
